var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgValueIcon = function SvgValueIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.125 9c8.353 0 15.125 3.693 15.125 8.25v5.5c0 4.557-6.772 8.25-15.125 8.25-8.205 0-14.883-3.563-15.118-8.007L4 22.75v-5.5C4 12.693 10.772 9 19.125 9m0 16.5c-5.115 0-9.639-1.385-12.375-3.506v.756c0 2.588 5.34 5.5 12.375 5.5 6.889 0 12.152-2.791 12.368-5.338l.007-.162.001-.756c-2.736 2.12-7.26 3.506-12.376 3.506M6.75 17.25c0-2.588 5.34-5.5 12.375-5.5S31.5 14.662 31.5 17.25s-5.34 5.5-12.375 5.5S6.75 19.838 6.75 17.25",
    clipRule: "evenodd"
  })));
};
export default SvgValueIcon;